
const digest = '16fdca05d879b14873569a9e3145ba5db40aaf2e0c0f5457f559bdcbec82ef2b';
const classes = {"text":"_text_l3xyb_1"};
const css = `._text_l3xyb_1 {
  font-size: 14px;
  margin-bottom: 15px;
  font-weight: 600;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  